import { useCallback, useEffect, useState } from 'react';

import BaseService from '../../../services/BaseService';

import { compareAuditByTimestampDesc } from './formatAuditHistorico';

// Cache por URL. Não se invalida sozinho: depois de salvar, chame `refetch()`.
const historicoCache = new Map();

const normalizeHistoricoResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

/** Histórico de auditoria (`[{ message, timestamp, username, fields[] }]`) de qualquer endpoint. */
export const useAuditHistorico = (url, { enabled = true } = {}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const fetchHistorico = useCallback(async ({ force = false } = {}) => {
    if (!url || !enabled) return;

    if (!force && historicoCache.has(url)) {
      setItems(historicoCache.get(url));
      setLoadError(false);
      return;
    }

    setLoading(true);
    setLoadError(false);

    try {
      const response = await BaseService.get({ url });
      const list = normalizeHistoricoResponse(response.data)
        .slice()
        .sort(compareAuditByTimestampDesc);

      historicoCache.set(url, list);
      setItems(list);
    } catch {
      setItems([]);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [url, enabled]);

  useEffect(() => {
    if (!enabled) {
      setItems([]);
      setLoadError(false);
      return;
    }
    fetchHistorico();
  }, [enabled, fetchHistorico]);

  const refetch = useCallback(
    () => fetchHistorico({ force: true }),
    [fetchHistorico],
  );

  return {
    items,
    loading,
    loadError,
    refetch,
  };
};

export default useAuditHistorico;
